<template>
  <div class="container">
    <div class="mwow-detail-header">
      <div class="left">
        <div class="back-btn" @click="handleBack">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="mid">
        <p>意向名单</p>
      </div>
    </div>
    <div class="head-btns">
      <el-button
        class="mwow-button-filled primary"
        @click="handleExport"
        v-debounce="1000"
        >导出</el-button
      >
    </div>
    <el-form class="mwow-wrap form" size="mini">
      <el-row>
        <el-col :span="8">
          <el-form-item label="学员:" prop="keyword">
            <el-input
              v-model="searchInfo.keyword"
              placeholder="请输入学员姓名或手机号"
              clearable
              @change="handleSearch"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="市场顾问:" prop="title">
            <el-select
              v-model="searchInfo.market_staff_id"
              placeholder="请输入市场顾问姓名或手机号"
              clearable
              filterable
              :filter-method="handleSearchMarketStaff"
              @change="handleSearch"
            >
              <el-option
                v-for="item in market_staff_list"
                :key="item.staff_id"
                :label="item.name"
                :value="item.staff_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="创建时间:" prop="create_time">
            <common-date-range-selector
              v-model="searchInfo.create_time"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              @change="handleSearch"
              :picker-options="effectiveDate"
            >
            </common-date-range-selector>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="提交状态:" prop="commit_status">
            <el-radio-group
              v-model="searchInfo.commit_status"
              @change="handleSearch"
            >
              <el-radio-button :label="-1">全部</el-radio-button>
              <el-radio-button :label="1">已提交</el-radio-button>
              <el-radio-button :label="2">未提交</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="意向科目:" prop="subject_ids">
            <el-select
              v-model="searchInfo.subject_ids"
              placeholder="请选择意向科目"
              clearable
              @change="handleSearch"
              multiple
            >
              <el-option
                v-for="item in subjectsList"
                :key="item.subject_id"
                :label="item.subject_title"
                :value="item.subject_id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <br />
    <el-table
      size="mini"
      :data="tableData"
      stripe
      ref="tableRef"
      style="width: 100%"
      tooltip-effect="dark"
      class="table"
    >
      <el-table-column label="序号" type="index" width="70"> </el-table-column>
      <el-table-column label="学员姓名" prop="name" width="100">
        <template slot-scope="scope">
          {{ scope.row.name ? scope.row.name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="mobile"> </el-table-column>
      <!-- 没有自定义预设表单时，默认显示固定表单项 -->
      <template v-if="itemRosterTitle.length === 0">
        <el-table-column label="性别" prop="gender">
          <template>{{ "-" }}</template>
        </el-table-column>
        <el-table-column label="出生日期" prop="birth">
          <template>{{ "-" }}</template>
        </el-table-column>
        <el-table-column label="地址区域" prop="area">
          <template>{{ "-" }}</template>
        </el-table-column>
      </template>
      <!-- 此处为添加的自定义预设表单 -->
      <template v-if="itemRosterTitle.length > 0">
        <el-table-column
          v-for="(item, index) in itemRosterTitle"
          :key="index"
          :label="item.title"
        >
          <template slot-scope="scope">
            <div>
              {{
                scope.row.roster_form_list[index]
                  ? scope.row.roster_form_list[index].form_value
                  : "-"
              }}
            </div>
          </template>
        </el-table-column>
      </template>
      <el-table-column label="定位地址" prop="location_address">
        <template slot-scope="scope">
          {{ scope.row.location_address ? scope.row.location_address : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="出现方式" prop="appear_name"> </el-table-column>
      <el-table-column
        label="来源渠道"
        prop="student_source.name"
      ></el-table-column>
      <el-table-column label="市场顾问" prop="market_staff.name">
        <template slot-scope="scope">
          {{ scope.row.market_staff ? scope.row.market_staff.name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="支付金额" prop="paid_amount" v-if="is_pay === 1">
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time"> </el-table-column>
      <el-table-column label="提交状态" prop="commit_status">
        <template slot-scope="scope">
          {{ scope.row.commit_status === 1 ? "已提交" : "未提交" }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import {
  getActivityRosterListApi,
  exportActivityRosterListApi,
  getMarketStaffListApi,
  getActivityRosterHeaderListApi,
} from "@/api/marketActivity";
import { dateFormat } from "@/utils/timeFormat";
import { exportLoop } from "@/utils/export";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import { subjectList } from "@/api/subject";

export default {
  name: "viewList",
  components: {
    commonDateRangeSelector,
  },
  data() {
    return {
      searchInfo: {
        commit_status: -1,
      },
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      tableData: [],
      market_staff_list: [],
      subject_ids: [],
      itemRosterTitle: [],
      is_pay: "",
      timer: "",
      subjectsList: [],
      effectiveDate: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        },
      },
    };
  },

  created() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
    this.getActivityRosterHeaderList();
    this.getMarketStaffListApiFn();
    this.is_pay = this.$route.query.is_pay;
    subjectList({
      page: 1,
      page_size: 50,
    }).then((res) => {
      if (res.error_code === 0) {
        this.subjectsList = res.data.list;
      }
    });
  },
  methods: {
    solveSearchInfo(option) {
      let params = { ...option };
      if (this.$route.query.activity_id) {
        params.activity_id = this.$route.query.activity_id;
      }
      if (this.searchInfo.keyword) {
        params.keyword = this.searchInfo.keyword;
      }
      if (this.searchInfo.market_staff_id) {
        params.market_staff_id = this.searchInfo.market_staff_id;
      }
      if (this.searchInfo.create_time) {
        params.create_start_time =
          new Date(this.searchInfo.create_time[0] + " 00:00:01").getTime() /
          1000;
        params.create_end_time =
          new Date(this.searchInfo.create_time[1] + " 23:59:59").getTime() /
          1000;
      }
      if (this.searchInfo.commit_status > 0) {
        params.commit_status = this.searchInfo.commit_status;
      }
      if (
        this.searchInfo.subject_ids &&
        this.searchInfo.subject_ids.length > 0
      ) {
        params.subject_ids = this.searchInfo.subject_ids;
      }
      return params;
    },
    getList(params) {
      let option = this.solveSearchInfo(params);
      getActivityRosterListApi(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((item) => {
            item.paid_amount = item.paid_amount === "" ? "-" : item.paid_amount;
            item.create_time = dateFormat(
              "YYYY-mm-dd HH:MM",
              new Date(item.create_time * 1000)
            );
            item.roster_form_list.forEach((it) => {
              // 找到多选类型的数据，只有多选类型会返回带 [] 的数据
              if (
                it.activity_form.preset_form_id > 5 &&
                it.activity_form.type === 3
              ) {
                // 多选的数据为空
                if (it.form_value.includes("[]")) {
                  it.form_value = "-";
                } else {
                  // 数据转换
                  it.form_value = JSON.parse(it.form_value).join(",");
                }
                // 14 为 意向科目，需要单独处理
              } else if (it.activity_form.preset_form_id === 6) {
                it.form_value = it.subject_list
                  .map((item) => {
                    return item.subject_title;
                  })
                  .join(",");
              }
            });
            let arr = [];
            // 将数据全部默认赋值为空（后端只返回有数据的，会导致展示错乱）
            this.itemRosterTitle.forEach((it, index) => {
              arr.push({
                activity_form: {
                  preset_form_id: this.itemRosterTitle[index].preset_form_id,
                  title: this.itemRosterTitle[index].title,
                  type: this.itemRosterTitle[index].type,
                  form_id: this.itemRosterTitle[index].form_id,
                },
                form_value: "-",
              });
            });
            // 将有数据的重新复赋值，避免错乱
            arr.forEach((it) => {
              item.roster_form_list.forEach((i) => {
                if (
                  it.activity_form.preset_form_id ===
                  i.activity_form.preset_form_id
                ) {
                  it.form_value = i.form_value;
                  it.activity_form = i.activity_form;
                }
              });
            });
            item.roster_form_list = arr;
          });
          this.tableData = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },
    getActivityRosterHeaderList() {
      getActivityRosterHeaderListApi({
        activity_id: Number(this.$route.query.activity_id),
      }).then((res) => {
        if (res.error_code === 0) {
          // 过滤出不带姓名和手机号的表头
          this.itemRosterTitle = res.data.list
            .filter((item) => {
              if (item.preset_form_id !== 1) {
                return item;
              }
            })
            .filter((item) => {
              if (item.preset_form_id !== 4) {
                return item;
              }
            });
        }
      });
    },
    // 获取市场顾问列表
    getMarketStaffListApiFn(v) {
      getMarketStaffListApi({
        page: 1,
        page_size: 100,
        keyword: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.market_staff_list = res.data.list;
        }
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    // 模糊搜索 - 市场顾问
    handleSearchMarketStaff(v) {
      this.debounce(this.getMarketStaffListApiFn, v, 500);
    },
    debounce(fn, data, delay) {
      // 设置一个触发开关
      let _t = this;
      clearTimeout(_t.timer);
      _t.timer = setTimeout(() => {
        fn(data);
      }, delay);
    },
    handleExport() {
      let option = this.solveSearchInfo({
        page: this.page,
        page_size: this.pageSize,
      });
      exportActivityRosterListApi(option).then((res) => {
        if (res.error_code === 0) {
          exportLoop(res.data.task_id);
        }
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handleBack() {
      this.$router.push({
        name: "activityManagement",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 70px 12px;
  border-radius: 4px;
  .head-btns {
    margin-top: 20px;
  }
}
/deep/.form {
  padding-top: 20px;
  .el-form-item {
    display: flex;
    .el-form-item__label {
      min-width: 80px !important;
    }
    .el-form-item__content {
      width: 74%;
      div:nth-child(1) {
        width: 100%;
      }
    }
  }
}

.table {
  .btns {
    display: flex;
  }
}
</style>
